import { useCallback, useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HeadlessContext from '../context/index.js';
import { REDUX_SLICE_NAME } from '../constants/index.js';
const useStorage = () => useContext(HeadlessContext).storage;
const useGlobalState = ({ namespace, key, persist, defaultValue }) => {
    const dispatch = useDispatch();
    const storage = useStorage();
    const valueRef = useRef();
    const value = useSelector((state) => state[REDUX_SLICE_NAME][namespace]?.[key] ?? defaultValue);
    useEffect(() => {
        valueRef.current = value;
    }, [value]);
    const setValue = useCallback((newValue) => {
        if (typeof newValue === 'function')
            newValue = newValue(valueRef.current);
        if (persist)
            storage?.set({ namespace, key, value: newValue });
        dispatch({ type: 'UI_SET', payload: { namespace, key, value: newValue } });
    }, [persist, storage, namespace, key, dispatch]);
    return [value, setValue];
};
export default useGlobalState;
